module.exports = __webpack_public_path__ + "img/logo-easypallet-white.9dc6022a.png";